import {ViewIcon, ViewOffIcon} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container, Flex,
  FormControl,
  FormLabel, IconButton, Image,
  Input, InputGroup, InputRightElement, Spacer,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import React, {useEffect, useState} from "react";
import {useMutation, useQueryClient} from "react-query";
import {useNavigate, useParams} from "react-router-dom";

import {getCandidateToken} from "../Api";
import {
  LoginParams,
  useAuthentication,
} from "../hooks/AuthenticationProvider";
import {disableBlurProtection} from "../hooks/BlurProtection";
import {useTheme} from "../hooks/ThemeProvider";
import {Paths} from "../model/Constants";
import { publicKeys} from "../QueryKeys";
import {enableKeyCommands} from "../Utils";

const TestLogin = () => {
  const themeContext = useTheme();
  const [show, setShow] = useState(false)
  const handleClick = () => setShow(!show)
  const params = useParams<{
    publicId: string;
  }>();

  disableBlurProtection();
  enableKeyCommands();

  const navigate = useNavigate();
  const authentication = useAuthentication();
  const queryClient = useQueryClient();

  const publicId = params.publicId || "";
  const [candidateToken, setCandidateToken] = useState<string>("");

  const fetchCandidateToken = useMutation(
      ({ publicId }: any) => getCandidateToken(publicId),
      {
        onSuccess: (TData) => {
          setCandidateToken(TData.status === 404 ? "" : TData.data);
          return queryClient.invalidateQueries(publicKeys.candidateByPublicId(publicId));
        }
      }
  );
  
  const startTest = () => {
    navigate(Paths.TESTS_PUBLIC_ID.replace(
        ":publicId",
        publicId).replace(
        ":candidateToken",
            candidateToken)
    , { replace: true });
  };

  useEffect(() => {
    if ( authentication.currentUserQuery && authentication.currentUserQuery.data &&
        authentication.currentUserQuery.isSuccess &&
        authentication.currentUserQuery.data.status !== 401
    ) {
      if (!fetchCandidateToken.data){
        fetchCandidateToken.mutate({publicId});
      } else {
        if (fetchCandidateToken.data && fetchCandidateToken.data.status !== 404){
          startTest();
        } else {
          navigate(Paths.HOME, { replace: true });
        }
      }
    }}, [authentication.currentUserQuery?.data, fetchCandidateToken.data]);
      
  if (
    !authentication.currentUserQuery ||
    authentication.currentUserQuery.isLoading || fetchCandidateToken.isLoading
  ) {
    return <Spinner />;
  }
  return (
    <Container maxW="container.lg" marginX="auto"
          filter= {'grayscale('+themeContext.theme.IMG_GRAYSCALE+') contrast('+themeContext.theme.IMG_CONTRAST+')'}>
      <Box
          bgImage="'/images/img-1e0eab8174642bd1921638f9bd71e94648399338.jpg'"
          bgSize= "cover" bgRepeat= "no-repeat"
          minHeight="610px"  width="100%" height="auto"
          borderWidth='1px' borderRadius='lg'>

        <Box paddingTop={5} />

        <Flex justify="center" align="space-between" paddingLeft={5}>
          <Box width="2xl">
            <Container maxW="container.sm">
              <Formik
                  initialValues={
                    {
                      username: "",
                      password: "",
                    } as LoginParams
                  }
                  onSubmit={(values: LoginParams) =>
                      authentication.loginMutation?.mutate(values)
                  }
              >
                <Form>
                  <Field name="username">
                    {({ field }: any) => (
                        <FormControl>
                          <FormLabel htmlFor="username">Name</FormLabel>
                          <Input {...field} id="username" />
                        </FormControl>
                    )}
                  </Field>
                  <Field name="password">
                    {({ field }: any) => (
                        <FormControl>
                          <FormLabel htmlFor="password">ID</FormLabel>
                          <InputGroup>
                            <Input {...field} id="password" type={show ? 'text' : 'password'} />
                            <InputRightElement >
                              <IconButton aria-label={"Mostrar"}
                                          onClick={handleClick}
                                          backgroundColor="transparent"
                                          icon={show ? <ViewOffIcon /> : <ViewIcon />} />
                            </InputRightElement>
                          </InputGroup>
                        </FormControl>
                    )}
                  </Field>
                  <Button
                      mt={4}
                      colorScheme={themeContext.theme.COLOR_SCHEME}
                      type="submit"
                      isLoading={authentication.loginMutation?.isLoading}
                  >
                    Entrar
                  </Button>
                  {authentication.loginMutation?.isError && (
                      <Text mt={4}>Por favor revise su usuario y contraseña</Text>
                  )}
                </Form>
              </Formik>
            </Container>
          </Box>
          <Spacer/>
          <Image
              src="/images/b996-2e23-0d3e-e998.png"
              maxH="xl"
              alignSelf="center"
          />
        </Flex>
        <Box paddingBottom={5} />
        <Image
               src="/images/51b7-15d0-10a4-f7ae.png"
               maxH="6rem" bottom="16px" />
      </Box>
    </Container>
  );
};

export default TestLogin;
